import { Link, useNavigate } from "react-router-dom";
import { useState } from "react";
import { fetchUserProfile } from "../redux/slices/profileSlice";
import { setToken } from "../redux/slices/authSlice";
import { useDispatch } from "react-redux";

function AdminLogin() {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [step, setStep] = useState("login");
  const [phone, setPhone] = useState("");
  const [otp, setOtp] = useState("");
  const [loading, setLoading] = useState(false);
  const [errorMsg, setErrorMsg] = useState("");

  const validatePhone = () => {
    const p = phone.trim();
    if (!p) return "Phone number is required.";
    if (!/^\d{10}$/.test(p)) return "Enter a valid 10-digit phone number.";
    return "";
  };

  const validateOtp = () => {
    const o = otp.trim();
    if (!o) return "OTP is required.";
    if (!/^\d{4}$/.test(o)) return "Enter a valid 4-digit OTP.";
    return "";
  };

  const readErrorMessage = async (res) => {
    try {
      const data = await res.json();
      return (
        data?.message ||
        data?.error ||
        data?.Message ||
        `Request failed (${res.status})`
      );
    } catch {
      const txt = await res.text().catch(() => "");
      return txt || `Request failed (${res.status})`;
    }
  };

  const handleSendOtp = async (e) => {
    e.preventDefault();
    setErrorMsg("");

    const v = validatePhone();
    if (v) return setErrorMsg(v);

    setLoading(true);
    try {
      const res = await fetch(
        "https://3d8d71qhr3.execute-api.ap-south-1.amazonaws.com/Prod/Auth/Login",
        {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ phone: phone.trim() }),
        },
      );

      if (!res.ok) throw new Error(await readErrorMessage(res));

      setStep("otp");
      setOtp("");
    } catch (err) {
      setErrorMsg(err?.message || "Something went wrong.");
    } finally {
      setLoading(false);
    }
  };

  const handleVerifyOtp = async (e) => {
    e.preventDefault();
    setErrorMsg("");

    const v = validateOtp();
    if (v) return setErrorMsg(v);

    setLoading(true);
    try {
      const res = await fetch(
        "https://3d8d71qhr3.execute-api.ap-south-1.amazonaws.com/Prod/Auth/VerifyOtp",
        {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ phone: phone.trim(), otp: otp.trim() }),
        },
      );

      if (!res.ok) throw new Error(await readErrorMessage(res));

      const data = await res.json().catch(() => ({}));

      // Only users with role "admin" may access the admin panel.
      if (data?.user?.role !== "admin") {
        setErrorMsg("You are not allowed to access this page.");
        setOtp("");
        return;
      }

      if (data?.token) {
        localStorage.setItem("adminToken", data.token);
        localStorage.setItem("adminPhone", phone.trim());
        navigate("/manage/dashboard");
      }
    } catch (err) {
      setErrorMsg(err?.message || "Invalid OTP.");
    } finally {
      setLoading(false);
    }
  };

  const handleResendOtp = async () => {
    setErrorMsg("");
    const v = validatePhone();
    if (v) return setErrorMsg(v);

    setLoading(true);
    try {
      const res = await fetch(
        "https://3d8d71qhr3.execute-api.ap-south-1.amazonaws.com/Prod/Auth/Login",
        {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ phone: phone.trim() }),
        },
      );

      if (!res.ok) throw new Error(await readErrorMessage(res));

      setOtp("");
    } catch (err) {
      setErrorMsg(err?.message || "Failed to resend OTP.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <main className="blue-light-bg">
        <section className="container d-flex flex-column vh-100">
          <div className="row align-items-center justify-content-center g-0 h-lg-100 py-8">
            <div className="col-lg-5 col-md-8 py-8 py-xl-0">
              <div className="card shadow rounded-4">
                <div className="card-body p-6 d-flex flex-column rounded-5 gap-1">
                  <div className="text-center">
                    <img src="/assets/images/icon.png" width="70"></img>
                    <div className="text-center mt-3">
                      <h1 className="m-0 fw-bold h2 lh-sm">
                        {step === "login" ? "Sign in" : "Verify OTP"}
                      </h1>
                      {step === "login" ? (
                        <p className="fs-4 mb-0">Only for Registered users</p>
                      ) : (
                        <p className="fs-4 mb-0">
                          We have send 4 Digit OTP on (+91) {phone}
                        </p>
                      )}
                    </div>

                    {/* Error alert */}
                    {errorMsg ? (
                      <div className="text-danger text-start mt-2 p-0 fs-4 mb-0">
                        {errorMsg}
                      </div>
                    ) : null}
                  </div>

                  {/* ✅ STEP 1: Send OTP */}
                  {step === "login" ? (
                    <form className="needs-validation" onSubmit={handleSendOtp}>
                      <div className="mb-2">
                        <label className="form-label">Phone No.</label>
                        <input
                          type="text"
                          className="form-control"
                          placeholder="Enter Phone No."
                          value={phone}
                          onChange={(e) =>
                            setPhone(
                              e.target.value.replace(/\D/g, "").slice(0, 10),
                            )
                          }
                          disabled={loading}
                          inputMode="numeric"
                        />
                      </div>

                      <div className="d-flex justify-content-center mt-4">
                        <button
                          type="submit"
                          className="btn btn-primary rounded-3 px-8"
                          disabled={loading}
                        >
                          {loading ? (
                            <>
                              <span
                                className="spinner-border spinner-border-sm me-2"
                                role="status"
                                aria-hidden="true"
                              />
                            </>
                          ) : (
                            "Send OTP"
                          )}
                        </button>
                      </div>
                    </form>
                  ) : null}

                  {step === "otp" ? (
                    <form
                      className="needs-validation"
                      onSubmit={handleVerifyOtp}
                    >
                      <div className="mb-2">
                        <label className="form-label">Phone No.</label>
                        <input
                          type="text"
                          className="form-control"
                          value={phone}
                          disabled
                        />
                      </div>

                      <div className="mb-2 col-6">
                        <label className="form-label mt-1">
                          Enter 4 Digit OTP
                        </label>
                        <input
                          type="text"
                          className="form-control"
                          placeholder="Enter OTP"
                          value={otp}
                          onChange={(e) =>
                            setOtp(
                              e.target.value.replace(/\D/g, "").slice(0, 4),
                            )
                          }
                          disabled={loading}
                          inputMode="numeric"
                        />
                      </div>

                      <div className="d-lg-flex justify-content-between align-items-center mb-3">
                        <span
                          className="btn p-0 text-danger"
                          onClick={handleResendOtp}
                          disabled={loading}
                        >
                          <i className="bi bi-arrow-clockwise me-1"></i> Resend
                          OTP
                        </span>
                      </div>

                      <div className="d-flex justify-content-center mt-4">
                        <button
                          type="submit"
                          className="btn btn-primary rounded-3 px-8"
                          disabled={loading}
                        >
                          {loading ? (
                            <>
                              <span
                                className="spinner-border spinner-border-sm me-2"
                                role="status"
                                aria-hidden="true"
                              />
                            </>
                          ) : (
                            "Verify OTP"
                          )}
                        </button>
                      </div>
                    </form>
                  ) : null}
                </div>
              </div>
            </div>
          </div>
        </section>
      </main>
    </>
  );
}

export default AdminLogin;
